// type
import { Category, Category2, Colorfilter, Barcode } from 'iconsax-react';
import { AES, enc } from 'crypto-js';
import * as url from "../store/constant/Endpoints";
  
// icons
const icons = {
  navigation: Category,
  typography: Category2,
  color: Colorfilter,
  shadow: Barcode
};

// let permissionUser = localStorage.getItem("LoginData");
// let permissions = JSON.parse(permissionUser)?.permissions;

let permissionUser = localStorage.getItem('data');

  let decryptedData = null;
  if(permissionUser){
      try {
    // Code that may throw an exception
    decryptedData = AES.decrypt(permissionUser, url.encryptionSecret).toString(enc.Utf8);
    // ...
} catch (error) {
  console.log(error,"er")
}
  }
  
  const permissions = JSON.parse(decryptedData)?.permissions;


const allowedPermissions = permissions && permissions.length !== 0 ? permissions?.map(permission => permission?.permission) : [];

const permissionsAccessFunction = (brand) => {
  return allowedPermissions && allowedPermissions.length !== 0 && allowedPermissions?.some(permission => permission?.includes(brand));
}

// ==============================|| MENU ITEMS - roles ||============================== //

const categories = permissionsAccessFunction('categories') ? {
  id: 'utilities',
  title: 'Category',
  icon: icons.navigation,
  type: 'group',
  children: [
 
    allowedPermissions?.includes('get-categories') ? {
      id: 'category',
      title: 'Category',
      type: 'item',
      url: '/category/all-category',
      icon: icons.navigation,
      breadcrumbs: true
    } : null,

    allowedPermissions?.includes('register-categories') ? {
      id: 'create-category',
      title: 'Add Category',
      type: 'item',
      url: '/category/edit-category',
      icon: icons.navigation,
      breadcrumbs: true
    } : null,
  ].filter(Boolean)
} : null;

export default categories;
